module.exports = __webpack_public_path__ + "static/media/aptech.fcdef459.png";